import { getPgaBrandLogo } from "@/lib/colorScheme";
import { useColorScheme } from "@/providers/ColorSchemeProvider";
import { Link } from "@/router";

const NavLogo = ({ className }: { className?: string }) => {
  const { colorScheme } = useColorScheme();
  const { src, variant } = getPgaBrandLogo(colorScheme);
  const logoClassName = className ?? "h-[60px] w-[60px]";

  return (
    <Link to="/" className="shrink-0">
      <img
        src={src}
        alt="PGA"
        className={logoClassName}
        style={variant === "april-fools" ? { width: "auto", height: "auto" } : undefined}
        data-testid="pga-brand-logo"
      />
    </Link>
  );
};

export default NavLogo;
